/**
 * Popin
 */

import KeyCodes from '../KeyCodes';
import * as Page from '../template/page';
import GlobalVars from '../GlobalVars';
import AjaxURL from '../AjaxURL';
import {
  defineCurrentHeight,
  offsetTop,
} from '../Utils';
import {
  openPopinEventName,
  closePopinEventName,
} from '../Events';
import {
  registerWindowResizeCallback,
} from '../tools/WindowResizeHandler';
import { mainPanelId } from '../Algolia';

const _ = {};
_.template = require('lodash/template');

const popins = 'js-popin';
const popinsOpen = 'o-popin--show';
const closeBtn = 'js-popin-close';
const validBtn = 'js-popin-valid';
const cancelBtn = 'js-popin-cancel';
const linkAttr = 'data-popin';
const openLink = `[${linkAttr}]`;
const popinTop = 'o-popin--top';
const popinCustom = 'o-popin--custom-newsletter';
const popinContent = 'o-popin__content';
const popinContained = 'o-popin--contained';
let popinTemplateId = 'popinTemplate';
const popinTemplateIdTop = 'popinTemplateTop';
const popinTemplateIframe = 'popinTemplateIframe';
const popinBody = 'js-popinBody';
const popinRoutine = 'popin-add-to-cart-routine';
let scrollPosition = 0;

const popinOverlayId = '#popinOverlay';
const popinOverlayTag = 'js-popin-overlay';
const popingOverlayHideClass = 'o-popin-overlay--hide';

const popinMaxHeight = 650;

const popinValidEvent = 'valid.popin';
const popinCancelEvent = 'cancel.popin';

window.OCMS.Popin = OCMS.Popin;

/**
 * Return the jQuery element from a selector
 * @param  {jQuery|string} elem jQuery element or a selector.
 * @return {jQuery}        Return the jQuery element.
 */
function getJQueryElem(elem) {
  let $elem = elem;
  if (typeof $elem === 'string') $elem = $($elem);
  return $elem;
}

/**
 * Return the opening status of a popin
 * @param  {jQuery|string} elem Popin element or selector.
 * @return {boolean}       Return true when the popin is open.
 */
function isOpen(elem) {
  const $elem = getJQueryElem(elem);
  return $elem.hasClass(popinsOpen);
}

/**
 * Return the min z-index of displayed popins
 * @return {int|null}
 */
// function getMinZindex() {
//   let zindex = null;
//   $(`.${popins}:visible`).each((i, e) => {
//     if (zindex === null) {
//       zindex = $(e).css('z-index');
//     } else {
//       zindex = Math.min(zindex, $(e).css('z-index'));
//     }
//   });
//   return zindex;
// }

/**
 * Return the max z-index of displayed popins
 * @return {int|null}
 */
function getMaxZindex() {
  let zindex = null;
  $(`.${popins}:visible`).each((i, e) => {
    if (zindex === null) {
      zindex = $(e).css('z-index');
    } else {
      zindex = Math.max(zindex, $(e).css('z-index'));
    }
  });
  return zindex;
}

/**
 * Close a popin
 * @param  {jQuery|string} elem Popin element or selector.
 */
function close($popin) {
  if ($popin.length) {
    $popin
      .removeClass(popinsOpen)
      .attr('aria-hidden', true)
      .css('height', '')
      .attr('tabindex', -1);

    if ($(`.${popins}:visible:not(.${popinTop})`).length === 0) {
      Page.scrollUnlocked();
      $('html, body').animate({ scrollTop: scrollPosition }, 100);
    }

    $(popinOverlayId).addClass(popingOverlayHideClass);

    $popin.trigger(closePopinEventName);
  }
}

/**
 * Give back the focus after the last focusable element
 * @param  {object} event
 * @param  {object} $popin jquery popin element
 * @return {boolean} can focus the next element
 */
function nextTrap(event, $popin) {
  const $elem = $(event.target);
  const $focusable = $popin;
  $focusable.push($popin.find(':focusable'));

  // Block after the last focusable element
  if ($focusable.index($elem) === ($focusable.length - 1)) {
    event.stopPropagation();
    $focusable.eq(0).focus();
    return false;
  }
  return true;
}

/**
 * Give the focus to the last focusable element before the popin
 * @param  {object} event
 * @param  {object} $popin jquery popin element
 * @return {boolean} can focus the previous element
 */
function prevTrap(event, $popin) {
  const $elem = $(event.target);
  const $focusable = $popin;
  $focusable.push(...$popin.find(':focusable'));

  // Block before the popin element
  if (!$focusable.index($elem)) {
    event.stopPropagation();
    $focusable.eq($focusable.length - 1).focus();
    return false;
  }
  return true;
}

/**
 * Keydown handler
 * @param  {Event} event Event object
 * @return {boolean}       Return false when preventing default.
 */
function keydownHandler(event) {
  const $popin = $(event.currentTarget);

  if (event.altKey) {
    // do nothing
    return true;
  }

  switch (event.keyCode) {
    case KeyCodes.esc: {
      event.stopPropagation();
      close($popin);
      $popin.trigger(popinCancelEvent);
      return false;
    }
    case KeyCodes.tab: {
      return event.shiftKey ? prevTrap(event, $popin) : nextTrap(event, $popin);
    }
    default: {
      break;
    }
  }

  return true;
}

/**
 * Centering Popin
 * @param  {jQuery|string} elem Popin element or selector.
 */
function centerPosition(elem) {
  const $popin = $(elem);

  if ($popin.hasClass(popinTop)) {
    return false;
  }

  const winH = $(window).height();
  const winW = $(window).width();

  $popin.find(`.${popinContent}`).css('top', (winH / 2) - ($popin.find(`.${popinContent}`).outerHeight() / 2));
  $popin.find(`.${popinContent}`).css('left', (winW / 2) - ($popin.find(`.${popinContent}`).outerWidth() / 2));

  return true;
}

/**
 * Display
 * @param  {jQuery|string} elem Popin element or selector.
 * @param  {jQuery}     $opener Opener jQuery element
 */
function display(elem, $opener) {
  const $popin = getJQueryElem(elem);
  const maxZindex = getMaxZindex();

  $popin
    .addClass(popinsOpen)
    .attr('aria-hidden', false)
    .attr('tabindex', 0)
    .focus();

  if (maxZindex !== null) {
    $popin.css('z-index', maxZindex + 5);
  }

  // On close, give back the focus to the opener element
  if ($opener && $opener.length > 0) {
    $popin.on(closePopinEventName, () => $opener.focus());
  }

  if ($(`.${popins}:visible:not(.${popinTop})`).length > 0) {
    Page.scrollLocked();
    centerPosition($popin);
  }

  // Load jQuery UI for the :focusable selector
  require('jqueryUi');// eslint-disable-line global-require
}

/**
 * display methode for animate popin
 * @param  {jQuery|string} elem Popin element or selector.
 * @param  {jQuery}     $opener Opener jQuery element
 */
function displaySlide(elem, $opener) {
  const $elem = getJQueryElem(elem);
  const height = defineCurrentHeight($elem);
  display($elem, $opener);
  setTimeout(() => {
    if (popinRoutine) {
      $elem.css('height', '100%');
    } else {
      $elem.css('height', height);
    }
    offsetTop($elem);
  }, 50);
}


/**
 * Return if the popin is a top one
 * @param  {jQuery|string} elem Popin element or selector.
 * @return {boolean}       Return true when the popin is a top one.
 */
function isTop(elem) {
  const $elem = getJQueryElem(elem);

  return $elem.hasClass(popinTop);
}

/**
 * Return true if the popin has the overlay tag
 * @param  {jQuery|string} elem Popin element or selector.
 * @return {boolean}       Return true when the popin is a top one.
 */
function hasOverlay(elem) {
  const $elem = getJQueryElem(elem);

  return $elem.hasClass(popinOverlayTag);
}

/**
 * Handles height overflow for one or all popins.
 * @param {Object} aoPopinContainer - The popin container.
 */
function handleHeightOverflow(aoPopinContainer) {
  let $popins = $(aoPopinContainer);

  if (!$popins.length) {
    $popins = $(`.${popins}`);
  }

  $popins.each((anIndex, aoElement) => {
    const $popinContainer = $(aoElement);

    if (
      ($popinContainer.css('display') === 'none') ||
      !$popinContainer.hasClass(popinCustom)
    ) {
      return true; // continue
    }

    const $popinContentContainer = $popinContainer.find(`.${popinContent}`);

    if (!$popinContentContainer.length) {
      return true; // continue
    }

    const $images = $popinContentContainer.find('.o-popin__body img');

    // Reset height
    $images.add($popinContentContainer).css('height', 'auto');

    // Check if images are loaded
    $images.each((anImageIndex, aoImageElement) => {
      if (aoImageElement.offsetHeight === 0) {
        const newImage = new Image();

        newImage.onload = () => {
          handleHeightOverflow($popins);
        };

        newImage.src = $(aoImageElement).attr('src');

        return false; // break
      }

      return true;
    });

    setTimeout(() => {
      const popinHeight = $popinContentContainer.outerHeight();
      let extraHeight = 0;

      const viewportHeight = $(window).height();
      const maxHeight = (
        (viewportHeight === 0) || (popinMaxHeight < viewportHeight)
      ) ? popinMaxHeight : viewportHeight;

      if (popinHeight > maxHeight) {
        extraHeight = popinHeight - maxHeight;
      }

      if (extraHeight > 0) {
        const imagesCount = $images.length;

        $images.each((anImageIndex, aoImageElement) => {
          $(aoImageElement).css('height', aoImageElement.offsetHeight - Math.ceil(extraHeight / imagesCount));
        });
      }

      setTimeout(() => {
        // Force centering of the popin except for the top one
        centerPosition($popinContainer);
      }, 0);
    }, 100);

    return true;
  });
}

/**
 * Open a popin
 * @param  {jQuery|string} elem Popin element or selector.
 * @param  {jQuery}     $opener Opener jQuery element
 */
function open(elem, $opener) {
  const $elem = getJQueryElem(elem);

  scrollPosition = $(window).scrollTop();

  if (hasOverlay($elem)) {
    $(popinOverlayId).removeClass(popingOverlayHideClass);
  }

  if (isTop($elem)) {
    displaySlide($elem, $opener);
  } else {
    display($elem, $opener);
  }

  // Handle height overflow
  if (!GlobalVars.IsMobile) {
    handleHeightOverflow($elem);
  }

  $elem.trigger('open.popin');
}

/**
 * Remove a popin
 * @id  {string} The id attribute of the targetted popin
 * @return  {boolean} Return true if a popin have been removed, false otherwise
 */
function remove(id) {
  const $popin = $(`#${id}`);

  if ($popin.length) {
    $popin.remove();
    return true;
  }
  return false;
}

/**
 * Create a popin
 * @param  {string} content   html content
 * @param  {string} id        element id
 * @param  {bool}   params.replace   replace popin body if already exists
 * @param  {bool}   params.replaceFull   replace popin body and header if already exists
 * @param  {bool}   params.top       use top template
 * @param  {string}   params.container       use another selector container to append the popin
 */
function create(content, id, params = {}) {
  const options = $.extend({
    replace: false,
    contentWithHeader: false,
    top: false,
    container: null,
    overlay: false,
  }, params);

  let $popin = $(`#${id}`);

  if (!$popin.length) {
    if (options.top) {
      popinTemplateId = popinTemplateIdTop;
    }

    // Special korea-zip form style override
    if (id === 'korea-zip') {
      popinTemplateId = popinTemplateIframe;
    }

    // Get popin template
    const renderTpl = _.template($(`#${popinTemplateId}`).html());
    $popin = $(`${renderTpl({ id, content })}`);

    // Add it in the dom
    let $wrapper = options.container !== null ? $(options.container).first() : $('#aspnetForm');
    if (options.container !== null && $wrapper.length) {
      $popin.addClass(popinContained);
    }

    if (options.overlay) {
      $popin.addClass(popinOverlayTag);
    }

    if (options.contentWithHeader) {
      $popin.find(`.${popinContent}`).html(content);
    }

    if (!$wrapper.length) {
      $wrapper = $('body');
    }

    $wrapper.append($popin);
  } else if (options.replace) {
    if (options.contentWithHeader) {
      $popin.find(`.${popinContent}`).html(content);
    } else {
      $popin.find(`.${popinBody}`).html(content);
    }
  }

  // Looking for a title and give it the right id for accessibility
  const $title = $popin.find('h1, h2, h3, h4, h5, h6').eq(0);
  if ($title.length) {
    $title.attr('id', `${id}Label`);
  }

  return $popin;
}

/**
 * Create popin from dictionary key
 * @param  {string} id    Popin Id
 */
function createFromDK(id, $opener) {
  $.get(
    AjaxURL.dicokey,
    {
      task: 'getdicovalue',
      key: `Popin${id}`,
      format: 'raw',
      c: GlobalVars.C,
      l: GlobalVars.L,
    },
    (content) => {
      const $popin = create(content, id);
      display($popin, $opener);
    }
  );
}

/**
 * Create popin from dictionary key
 * @param  {string} tplId    template Id
 * @param  {string} id    Popin Id
 */
function createFromTpl(tplId, id, paramTpl = {}, $opener) {
  const contentTpl = _.template($(`${tplId}`).html());
  const renderPopin = contentTpl(paramTpl);

  const $popin = create(renderPopin, id);
  display($popin, $opener);
}

function handleOpenEvent() {
  $(document).on(openPopinEventName, (aoEvent, aoPopinContainer, aoCallback) => {
    open(aoPopinContainer);

    if (aoCallback && (typeof aoCallback === 'function')) {
      aoCallback();
    }
  });
}

/**
 * Init handlers
 */
function init() {
  $(document)
    // Init keyboard handler
    .on('keydown', `.${popins}`, keydownHandler)
    // Init close buttons
    .on('click', `.${popins} .${closeBtn}, .${popins} .${cancelBtn}`, (event) => {
      const $popin = $(event.currentTarget).parents(`.${popins}`);
      close($popin);

      $popin.trigger(popinCancelEvent);
    })
    // Init valid btn
    .on('click', `.${popins} .${validBtn}`, (event) => {
      const $popin = $(event.currentTarget).parents(`.${popins}`);
      close($popin);

      $popin.trigger(popinValidEvent);
    });

  // Init opening links (Handle special cross site case for Algolia instant search)
  $(document).on('click', ((GlobalVars.IsReskinV2) ? `#${mainPanelId} ${openLink}` : openLink), (event) => {
    const $opener = $(event.currentTarget);
    const popinId = $opener.data('popin');
    const $popin = $(`#${popinId}`);

    // Open the popin if exists in DOM
    if ($popin.length) {
      open($popin, $opener);
    } else {
      // Or create the popin with dico key content
      createFromDK($opener.attr(linkAttr), $opener);
    }
  });

  // Handle open event
  handleOpenEvent();

  // Handle window resize
  if (!GlobalVars.IsMobile) {
    registerWindowResizeCallback(() => {
      handleHeightOverflow();
    });
  }
}

// Export constants
export {
  popinBody,
  popinValidEvent,
  popinCancelEvent
};

// Export named functions
export {
  init,
  isOpen,
  create,
  remove,
  open,
  close,
  display,
  createFromTpl
};



// WEBPACK FOOTER //
// ./js/common/organism/popin.js